/*
 * One place where the storefront talks to Google Tag Manager.
 *
 * Everything goes through window.dataLayer, because GA4 on this store is
 * loaded by GTM (GTM-PJHC288H) and gtag() does not exist on the page. GTM
 * forwards the events to GA4, Meta and Clarity from one container; the theme
 * never loads a vendor pixel itself.
 *
 * Two families of events:
 *   - GA4 ecommerce (view_item_list, select_item, view_item, add_to_cart,
 *     remove_from_cart, view_cart, begin_checkout, search) in the standard
 *     `ecommerce.items` shape, so GA4's Monetisation reports fill themselves;
 *   - cp_* events for the things this theme added on top of Horizon (stories,
 *     reward cards, size pick, colour switch, menu tiles, upsell, popup…),
 *     each with a `source` or `label` so a report can split by placement.
 *
 * Cart adds and removes are found by diffing the cart, not by hooking every
 * button: the product form, a size on a card, a story, the upsell row and
 * the drawer's +/− all end in a cart:update or cp:ladder event, and one diff
 * of "items before" against "items after" names exactly what changed.
 *
 * Money: GA4 wants major units — kopiykas / 100. Currency is always UAH.
 * No PII is ever pushed: no emails, no names, no addresses.
 */
(function () {
  if (window.__cpAnalytics) return;
  window.__cpAnalytics = true;

  var CURRENCY = 'UAH';
  var DEBUG = /[?&]cp_debug=1/.test(location.search) || localStorage.getItem('cp:debug') === '1';

  function dl() { return (window.dataLayer = window.dataLayer || []); }

  function push(event, params, ecommerce) {
    try {
      var payload = Object.assign({ event: event }, params || {});
      if (ecommerce) {
        // GTM keeps the previous ecommerce object otherwise, and GA4 would
        // attach stale items to the next event.
        dl().push({ ecommerce: null });
        payload.ecommerce = ecommerce;
      }
      dl().push(payload);
      if (window.clarity && typeof window.clarity === 'function') {
        try { window.clarity('event', event); } catch (e) {}
      }
      if (DEBUG) console.log('[cp-analytics]', event, payload);
    } catch (e) {}
  }
  window.cpTrack = push;

  function uah(cents) { return Math.round((Number(cents) || 0)) / 100; }

  /* GA4 item from a /cart.js line or a product-card data set. */
  function itemFromLine(line) {
    return {
      item_id: String(line.product_id),
      item_name: line.product_title || line.title,
      item_variant: line.variant_title || undefined,
      item_category: line.product_type || undefined,
      item_brand: line.vendor || 'Clean Project',
      sku: line.sku || undefined,
      price: uah(line.final_price != null ? line.final_price : line.price),
      quantity: line.quantity || 1,
    };
  }

  function itemFromCard(card, index, list) {
    var d = card.dataset;
    var item = {
      item_id: d.cpPid,
      item_name: d.cpTitle,
      item_category: d.cpType || undefined,
      item_brand: 'Clean Project',
      price: uah(d.cpPrice),
      quantity: 1,
    };
    if (list) { item.item_list_name = list; }
    if (index != null) { item.index = index; }
    return item;
  }

  /* ---------------------------------------------------------------- page */
  var main = document.querySelector('main');
  var template = (main && main.dataset.template) || document.body.dataset.template || '';
  var productJson = null;
  try {
    var el = document.getElementById('cp-product-json');
    if (el) productJson = JSON.parse(el.textContent);
  } catch (e) {}

  push('cp_page', {
    page_type: template || (productJson ? 'product' : 'other'),
    page_handle: productJson ? productJson.handle : undefined,
  });

  /* Collection filters applied (Search & Discovery renders them as URL
   * params) — read once per load, that is when they take effect. */
  (function () {
    var q = new URLSearchParams(location.search);
    var filters = [];
    q.forEach(function (v, k) { if (k.indexOf('filter.') === 0) filters.push(k.replace('filter.', '') + '=' + v); });
    if (filters.length) push('cp_filter_applied', { filters: filters.join('|'), count: filters.length });
    if (q.get('sort_by')) push('cp_sort', { sort_by: q.get('sort_by') });
    if (template === 'search' && q.get('q')) {
      push('view_search_results', { search_term: q.get('q'), results: document.querySelectorAll('.minimal-card').length });
    }
  })();

  /* ------------------------------------------------------------- product */
  if (productJson) {
    var v0 = productJson.variant || {};
    push('view_item', { currency: CURRENCY, value: uah(v0.price || productJson.price) }, {
      currency: CURRENCY,
      value: uah(v0.price || productJson.price),
      items: [{
        item_id: String(productJson.id),
        item_name: productJson.title,
        item_variant: v0.title,
        item_category: productJson.type,
        item_brand: productJson.vendor || 'Clean Project',
        price: uah(v0.price || productJson.price),
        quantity: 1,
      }],
    });
  }

  /* Size and colour on the product page. The size radios are the only
   * decision most customers make here (37% of DM objections are about
   * size), so a pick, the size guide and a shaken "оберіть розмір" are
   * each their own event. */
  document.addEventListener('change', function (event) {
    var radio = event.target.closest('.size-option-input');
    if (!radio || !radio.checked) return;
    push('cp_size_select', {
      size: radio.value,
      product_id: productJson ? String(productJson.id) : undefined,
      preorder: !!(radio.nextElementSibling && radio.nextElementSibling.classList.contains('is-preorder')),
      source: radio.closest('.cp-size-sheet') ? 'sheet' : 'pdp',
    });
  }, true);

  document.addEventListener('variant:update', function (event) {
    var r = event.detail && event.detail.resource;
    if (!r) return;
    push('cp_variant_update', { variant_id: String(r.id), available: !!r.available });
  });

  /* -------------------------------------------------------------- clicks */
  document.addEventListener('click', function (event) {
    var t = event.target;
    var a;

    if ((a = t.closest('.cp-size-guide-link'))) push('cp_size_guide_open', { source: a.closest('.cp-size-sheet') ? 'sheet' : 'pdp' });

    if ((a = t.closest('.cp-circles__item'))) push('cp_circle_click', { label: text(a), url: a.getAttribute('href') });

    if ((a = t.closest('.cp-menu-tile'))) push('cp_menu_click', { label: text(a.querySelector('.cp-menu-tile__label')) || text(a), url: a.getAttribute('href'), source: 'tile' });
    else if ((a = t.closest('.menu-drawer a, .header-menu a, .cp-menu-service a'))) push('cp_menu_click', { label: text(a), url: a.getAttribute('href'), source: 'link' });

    if ((a = t.closest('[data-cp-story]'))) push('cp_story_open', { story: text(a) || a.getAttribute('aria-label') });

    if ((a = t.closest('.cfaq-row'))) {
      var item = a.closest('.cfaq-item');
      if (item && !item.classList.contains('is-open')) push('cp_faq_open', { question: text(a).slice(0, 80) });
    }

    if ((a = t.closest('.card-color-swatches a, [data-cp-swatch]'))) push('cp_colour_switch', { colour: a.getAttribute('title') || '', source: 'card' });
    else if ((a = t.closest('.product-info a.color-swatch, .cp-colour a, .clean-color-swatch'))) push('cp_colour_switch', { colour: a.getAttribute('title') || text(a), source: 'pdp' });

    if ((a = t.closest('[data-cp-filters-open]'))) push('cp_filter_open', {});

    if ((a = t.closest('.minimal-card-nav, .minimal-card-dot'))) push('cp_card_swipe', { source: 'arrow' });

    if ((a = t.closest('.cp-plus'))) push('cp_quick_add_open', {});

    if ((a = t.closest('.cp-bar'))) push('cp_bar_click', { label: text(a).slice(0, 60) });

    if ((a = t.closest('.clean-sticky-bar .product-form__submit, .clean-sticky-bar button'))) push('cp_sticky_bar_click', {});

    if ((a = t.closest('.cp-goal'))) push('cp_reward_card_click', { label: text(a.querySelector('.cp-goal__label')) || text(a).slice(0, 40) });

    if ((a = t.closest('.dpop__close'))) push('cp_popup_close', {});

    if ((a = t.closest('a[href*="t.me/"], a[href*="instagram.com"], a[href*="tiktok.com"], a[href^="tel:"], a[href^="mailto:"]'))) {
      push('cp_contact_click', { channel: /t\.me/.test(a.href) ? 'telegram' : /instagram/.test(a.href) ? 'instagram' : /tiktok/.test(a.href) ? 'tiktok' : /^tel:/.test(a.href) ? 'phone' : 'email', location: a.closest('footer') ? 'footer' : a.closest('header') ? 'header' : 'page' });
    }

    /* select_item: the card link, with its list and position. */
    if ((a = t.closest('.minimal-card-link'))) {
      var card = a.closest('.minimal-card');
      if (card && card.dataset.cpPid) {
        var ctx = listOf(card);
        var item = itemFromCard(card, ctx.index, ctx.name);
        push('select_item', { item_list_name: ctx.name }, { item_list_name: ctx.name, items: [item] });
      }
    }

    /* begin_checkout: capture phase, before Chekly replaces the page. */
    if ((a = t.closest('[name="checkout"], .cart__checkout-button, a[href*="/checkout"]'))) {
      var cart = lastCart;
      var items = cart ? cart.items.filter(notGift).map(itemFromLine) : [];
      var value = cart ? uah(cart.items_subtotal_price) : undefined;
      push('begin_checkout', {
        currency: CURRENCY, value: value, items_count: cart ? cart.item_count : undefined,
        gift_unlocked: cart ? cart.items.some(function (l) { return l.properties && l.properties._gift === 'true'; }) : undefined,
        source: a.closest('.cart-drawer, cart-drawer-component') ? 'drawer' : a.closest('.clean-sticky-bar') ? 'sticky' : 'cart_page',
      }, { currency: CURRENCY, value: value, items: items });
    }
  }, true);

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function notGift(l) { return !(l.properties && l.properties._gift === 'true'); }

  /* ----------------------------------------------------- lists and cards */
  /* The list a card belongs to: an explicit data-cp-list on an ancestor, else
   * the nearest heading, else the page. Index is the card's position in
   * that container, which infinite scroll keeps growing. */
  function listOf(card) {
    var host = card.closest('[data-cp-list]');
    var name = host ? host.dataset.cpList : null;
    if (!name) {
      var sec = card.closest('.shopify-section, section');
      var h = sec && sec.querySelector('h1, h2');
      name = h ? text(h).slice(0, 60) : (template || 'page');
      host = sec;
    }
    var cards = host ? host.querySelectorAll('.minimal-card') : [];
    var index = Array.prototype.indexOf.call(cards, card) + 1;
    return { name: name, index: index > 0 ? index : undefined };
  }

  var seen = new WeakSet();
  var pending = {};
  var flushTimer = null;
  function flushLists() {
    flushTimer = null;
    Object.keys(pending).forEach(function (name) {
      var items = pending[name];
      push('view_item_list', { item_list_name: name, items_count: items.length }, { item_list_name: name, items: items.slice(0, 30) });
    });
    pending = {};
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting || en.intersectionRatio < 0.5) return;
      var card = en.target;
      io.unobserve(card);
      if (seen.has(card)) return;
      seen.add(card);
      var ctx = listOf(card);
      (pending[ctx.name] = pending[ctx.name] || []).push(itemFromCard(card, ctx.index, ctx.name));
      if (!flushTimer) flushTimer = setTimeout(flushLists, 800);
    });
  }, { threshold: 0.5 }) : null;

  function watchCards(root) {
    if (!io) return;
    (root || document).querySelectorAll('.minimal-card[data-cp-pid]').forEach(function (c) { if (!seen.has(c)) io.observe(c); });
  }
  watchCards();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) watchCards(n); }); });
  }).observe(document.body, { childList: true, subtree: true });

  /* ------------------------------------------------------------ sections */
  var SECTIONS = [
    ['.cp-stories', 'stories'], ['.cp-circles', 'category_circles'], ['.iotw', 'item_of_the_week'],
    ['[id^="CleanFaq-"]', 'faq'], ['.live-from-the-feed, .lff', 'live_feed'], ['.bullet, .clean-bullet', 'bullet'],
    ['.cp-news', 'newsletter'], ['.cp-pdp-service', 'pdp_service'], ['.cp-rvp', 'reviews_page'],
    ['.clean-reviews, .cp-reviews, [class*="review-carousel"]', 'reviews'], ['.cp-sale-grid', 'sale_grid'],
    ['.product-recommendations, .clean-product-recommendations', 'recommendations'], ['.simple-hotspot, .hero', 'hero'],
  ];
  if (io) {
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        sio.unobserve(en.target);
        push('cp_section_view', { section: en.target.dataset.cpSection });
      });
    }, { threshold: 0.4 });
    SECTIONS.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (el) {
        if (el.dataset.cpSection) return;
        el.dataset.cpSection = pair[1];
        sio.observe(el);
      });
    });
  }

  /* Scroll depth, once per threshold per page. */
  (function () {
    var marks = [25, 50, 75, 90], fired = {};
    var onScroll = function () {
      var h = document.documentElement;
      var pct = Math.round((window.scrollY + window.innerHeight) / Math.max(1, h.scrollHeight) * 100);
      marks.forEach(function (m) { if (pct >= m && !fired[m]) { fired[m] = true; push('cp_scroll', { percent: m }); } });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------------------------------------------------------------- cart */
  var lastCart = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function linesByKey(cart) {
    var m = {};
    (cart && cart.items || []).forEach(function (l) { m[l.key] = l; });
    return m;
  }

  function diffCart(next, source) {
    if (!next || !next.items) return;
    if (lastCart) {
      var before = linesByKey(lastCart), after = linesByKey(next);
      var added = [], removed = [];
      Object.keys(after).forEach(function (k) {
        var d = after[k].quantity - (before[k] ? before[k].quantity : 0);
        if (d > 0) added.push(Object.assign({}, after[k], { quantity: d }));
      });
      Object.keys(before).forEach(function (k) {
        var d = before[k].quantity - (after[k] ? after[k].quantity : 0);
        if (d > 0) removed.push(Object.assign({}, before[k], { quantity: d }));
      });
      var real = added.filter(notGift);
      if (real.length) {
        var items = real.map(itemFromLine);
        var value = items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
        push('add_to_cart', { currency: CURRENCY, value: value, source: source || 'unknown', cart_value: uah(next.items_subtotal_price), cart_items: next.item_count },
          { currency: CURRENCY, value: value, items: items });
      }
      if (added.some(function (l) { return !notGift(l); })) push('cp_gift_added', { cart_value: uah(next.items_subtotal_price) });
      var realRemoved = removed.filter(notGift);
      if (realRemoved.length) {
        var ri = realRemoved.map(itemFromLine);
        push('remove_from_cart', { currency: CURRENCY, value: ri.reduce(function (s, i) { return s + i.price * i.quantity; }, 0), source: source || 'unknown' },
          { currency: CURRENCY, items: ri });
      }
    }
    lastCart = next;
  }

  /* Horizon's product form, quantity selector and remove buttons all end in
   * cart:update; the cp-* modules (card size, story, upsell, gift) announce
   * through the same event with their own source. One diff names the change. */
  document.addEventListener('cart:update', function (event) {
    var d = event.detail || {};
    var src = (d.data && d.data.source) || d.sourceId || 'horizon';
    if (d.data && d.data.didError) return;
    var cart = d.resource && d.resource.items ? Promise.resolve(d.resource) : fetchCart();
    cart.then(function (c) { diffCart(c, normaliseSource(src, d)); }).catch(function () {});
  });
  document.addEventListener('cart:error', function (event) {
    var d = event.detail || {};
    push('cp_cart_error', { message: String(d.message || '').slice(0, 80) });
  });

  function normaliseSource(src, d) {
    if (/^product-form/.test(src)) return document.querySelector('.clean-sticky-bar.visible') ? 'pdp_sticky' : 'pdp';
    if (/quantity/i.test(src)) return 'drawer_qty';
    if (/remove/i.test(src)) return 'drawer_remove';
    return src;
  }

  /* view_cart: the drawer opening, and the cart page. */
  document.addEventListener('dialog:open', function (event) {
    var el = event.target;
    if (!el || !(el.matches && (el.matches('cart-drawer-component') || el.closest('cart-drawer-component')))) return;
    (lastCart ? Promise.resolve(lastCart) : fetchCart()).then(function (c) {
      lastCart = c;
      push('view_cart', { currency: CURRENCY, value: uah(c.items_subtotal_price), items_count: c.item_count, source: 'drawer' },
        { currency: CURRENCY, value: uah(c.items_subtotal_price), items: c.items.filter(notGift).map(itemFromLine) });
    }).catch(function () {});
  }, true);

  /* The first snapshot, so the first add has something to diff against. */
  var boot = function () {
    fetchCart().then(function (c) {
      lastCart = c;
      if (template === 'cart') {
        push('view_cart', { currency: CURRENCY, value: uah(c.items_subtotal_price), items_count: c.item_count, source: 'page' },
          { currency: CURRENCY, value: uah(c.items_subtotal_price), items: c.items.filter(notGift).map(itemFromLine) });
      }
    }).catch(function () {});
  };
  if ('requestIdleCallback' in window) requestIdleCallback(boot, { timeout: 2000 }); else setTimeout(boot, 1200);

  /* -------------------------------------------------------------- search */
  var typed = null;
  document.addEventListener('input', function (event) {
    var input = event.target.closest('input[type="search"][name="q"], .search-input');
    if (!input) return;
    clearTimeout(typed);
    typed = setTimeout(function () {
      var q = input.value.trim();
      if (q.length >= 2) push('search', { search_term: q, source: 'predictive' });
    }, 900);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches && form.matches('form[action*="/search"]')) {
      var q = form.querySelector('[name="q"]');
      push('search', { search_term: q ? q.value.trim() : '', source: 'submit' });
    }
    if (form.id === 'CpNewsForm') push('newsletter_signup', { source: 'footer' });
    if (form.id === 'DpopForm') push('newsletter_signup', { source: 'popup' });
    if (form.matches && form.matches('form[action*="/contact"]') && form.id !== 'CpNewsForm' && form.id !== 'DpopForm') push('cp_form_submit', { form: form.id || 'contact' });
  }, true);
  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.cp-chip, .cp-search-chip, [data-cp-chip]');
    if (chip) push('cp_search_chip_click', { label: text(chip), location: chip.closest('.search-modal, .predictive-search') ? 'search' : 'menu' });
  }, true);

  /* Discount popup: shown when its `hidden` attribute is dropped. */
  (function () {
    var pop = document.querySelector('[data-dpop]');
    if (!pop) return;
    new MutationObserver(function () {
      if (!pop.hidden && !pop.dataset.cpShown) { pop.dataset.cpShown = '1'; push('cp_popup_shown', {}); }
    }).observe(pop, { attributes: true, attributeFilter: ['hidden'] });
  })();

  /* Stories: frames already report story_view from cp-stories.js; here only
   * how long a viewer stays open, sent when it closes. */
  (function () {
    var openedAt = null;
    document.addEventListener('click', function (e) { if (e.target.closest('[data-cp-story]')) openedAt = Date.now(); }, true);
    document.addEventListener('close', function (e) {
      if (openedAt && e.target && e.target.matches && e.target.matches('dialog.cp-sv, dialog[class*="cp-sv"]')) {
        push('cp_story_close', { seconds: Math.round((Date.now() - openedAt) / 1000) });
        openedAt = null;
      }
    }, true);
  })();

  /* Delivery ETA shown on the product page, so "ships today" can be split
   * from "ships tomorrow" in the add-to-cart rate. */
  (function () {
    var eta = document.querySelector('[data-cp-eta], .cp-eta');
    if (eta) push('cp_eta_shown', { text: text(eta).slice(0, 60) });
  })();

  /* Errors from our own modules. */
  window.addEventListener('error', function (e) {
    if (e.filename && /cp-|clean-/.test(e.filename)) push('cp_js_error', { file: e.filename.split('/').pop(), message: String(e.message).slice(0, 80) });
  });
})();
